import { render, staticRenderFns } from "./Visit-Timestamp.vue?vue&type=template&id=f5006112&scoped=true"
import script from "./Visit-Timestamp.vue?vue&type=script&lang=js"
export * from "./Visit-Timestamp.vue?vue&type=script&lang=js"
import style0 from "./Visit-Timestamp.vue?vue&type=style&index=0&id=f5006112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5006112",
  null
  
)

export default component.exports